"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.globalTokens = exports.creDark = exports.creLight = exports.allhomesDark = exports.allhomesLight = exports.domainDark = exports.domainLight = void 0;
const domain_2020_1 = __importDefault(require("../../themes/domain-2020/domain-2020"));
const domain_2020_dark_1 = __importDefault(require("../../themes/domain-2020-dark/domain-2020-dark"));
const allhomes_1 = __importDefault(require("../../themes/allhomes/allhomes"));
const allhomes_dark_1 = __importDefault(require("../../themes/allhomes-dark/allhomes-dark"));
const cre_1 = __importDefault(require("../../themes/cre/cre"));
const cre_dark_1 = __importDefault(require("../../themes/cre-dark/cre-dark"));
const pricefinder_1 = __importDefault(require("../../themes/pricefinder/pricefinder"));
const pricefinder_dark_1 = __importDefault(require("../../themes/pricefinder-dark/pricefinder-dark"));
const tokens_1 = __importDefault(require("../../global/tokens"));
exports.globalTokens = tokens_1.default;
const allThemes = {
    domainLightTheme: domain_2020_1.default,
    domainDarkTheme: domain_2020_dark_1.default,
    allhomesLightTheme: allhomes_1.default,
    allhomesDarkTheme: allhomes_dark_1.default,
    creLightTheme: cre_1.default,
    creDarkTheme: cre_dark_1.default,
    pricefinderLightTheme: pricefinder_1.default,
    pricefinderDarkTheme: pricefinder_dark_1.default,
};
const entries = Object.entries;
const fromEntries = Object.fromEntries;
function convertThemeSpacingToPx(theme) {
    const convertedTheme = Object.assign(Object.assign({}, theme), { spacing: fromEntries(entries(theme.spacing).map(([key, value]) => [
            key,
            fromEntries(entries(value).map(([subKey, subValue]) => [subKey, `${subValue}px`])),
        ])) });
    return convertedTheme;
}
exports.domainLight = convertThemeSpacingToPx(domain_2020_1.default);
exports.domainDark = convertThemeSpacingToPx(domain_2020_dark_1.default);
exports.allhomesLight = convertThemeSpacingToPx(allhomes_1.default);
exports.allhomesDark = convertThemeSpacingToPx(allhomes_dark_1.default);
exports.creLight = convertThemeSpacingToPx(cre_1.default);
exports.creDark = convertThemeSpacingToPx(cre_dark_1.default);
//# sourceMappingURL=index.js.map